import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useEffect, useState } from 'react';
import Spinner from 'react-bootstrap/esm/Spinner';
import { resetPassword } from '../api/Communication';

function ForgotPassword({ showResetPwForm, onSuccess, onFail, role }) {
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setForm({
      role: role,
      to: '',
    });
  }, []);

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });

    if (!!errors[field])
      setErrors({
        ...errors,
        [field]: null,
      });
  };

  const findFormErrors = () => {
    const { to } = form;
    const newErrors = {};
    const validEmailRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    // email errors
    if (!to || to === '') {
      newErrors.to = 'Du måste ange en e-postadress.';
    } else if (validEmailRegex.test(to) === false) {
      newErrors.to = 'Felaktigt format på e-postadress.';
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setLoading(true);
      const status = await resetPassword(form);

      if (status.status === 500) {
        setLoading(false);
        showResetPwForm(false);
        onFail();
      }

      switch (status.statusCode) {
        case 200:
          setLoading(false);
          showResetPwForm(false);
          onSuccess();
          break;
        case 400:
          setLoading(false);
          showResetPwForm(false);
          onFail();
          break;
        case 409:
          setLoading(false);
          showResetPwForm(false);
          onFail();
          break;
      }
    }
  };

  const resetPwBtn = (
    <>
      {loading ? (
        <>
          <Spinner
            as='span'
            animation='border'
            size='sm'
            role='status'
            aria-hidden='true'
            className='me-2'
          />
          <span className='visually-hidden'>Loading...</span>
          Återställ lösenord
        </>
      ) : (
        'Återställ lösenord'
      )}
    </>
  );

  return (
    <div className='h-100 position-relative'>
      <div className='h-100 d-flex flex-column justify-content-between'>
        <span
          onClick={() => showResetPwForm(false)}
          className='d-flex align-items-center'
          role='button'
        >
          <span
            className='material-symbols-outlined'
            style={{ fontSize: '16px' }}
          >
            arrow_back_ios
          </span>
          Logga in
        </span>

        <div>
          <h4 className='mb-3'>Har du glömt lösenordet?</h4>
          <span>
            Ange din e-post för att få en återställningslänk till din mejl.
          </span>
        </div>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId='formEmail'>
            <Form.Label>E-post</Form.Label>
            <Form.Control
              className='p-2'
              type='email'
              name='email'
              placeholder='Ange e-post'
              onChange={(e) => setField('to', e.target.value)}
              isInvalid={!!errors.to}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.to}
            </Form.Control.Feedback>
          </Form.Group>

          <Button variant='primary' className='w-100 mt-3' type='submit'>
            {resetPwBtn}
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default ForgotPassword;
